import { IconButton, TextField, Box } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'

export default function SearchBar({
  filterParams,
  handleFilterButtons,
  showSearchBar,
  setShowSearchBar,
}) {
  var searchBar = ''

  const handleSearchInput = (event) => {
    handleFilterButtons({ ...filterParams, searchTerm: event.target.value })
  }

  const handleCancelSearch = () => {
    setShowSearchBar(false)
    handleFilterButtons({ ...filterParams, searchTerm: '' })
  }

  if (showSearchBar) {
    searchBar = (
      <Box sx={{ px: 2, py: 1, backgroundColor: 'whitesmoke' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            maxWidth: 480,
            mx: 'auto',
            width: '100%',
          }}
        >
          <TextField
            id="search-field"
            variant="outlined"
            size="small"
            label="Search drinks"
            placeholder="Name, ingredient, tag, or recipe text"
            value={filterParams.searchTerm || ''}
            onChange={handleSearchInput}
            autoFocus
            sx={{ flex: 1, minWidth: 0 }}
          />
          <IconButton
            color="primary"
            aria-label="Close search"
            onClick={() => handleCancelSearch()}
            sx={{ flexShrink: 0 }}
          >
            <CancelIcon />
          </IconButton>
        </Box>
      </Box>
    )
  }

  return searchBar
}
